import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Spinner } from 'reactstrap';

const Loader = ({ className = '' }) => (
  <Container fluid className='vh-50 d-flex'>
    <Row className='justify-content-center align-self-center w-100 text-center'>
      <Spinner color='primary' className={className} />
    </Row>
  </Container>
);

Loader.propTypes = {
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default Loader;
